/**
 * @generated SignedSource<<d32363a830592062acfb21aea27b2f27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublicMeetingRecapQuery$variables = {
  accessKey: string;
  data?: string | null;
};
export type PublicMeetingRecapQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_meetingRecording" | "TranscriptModal_note">;
  } | null;
  readonly publicRecap: {
    readonly domainUsers: ReadonlyArray<{
      readonly email: string;
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
    }> | null;
    readonly userExistsForEmail: boolean | null;
  };
  readonly viewer: {
    readonly account: {
      readonly __typename: "Account";
      readonly allowRecapDownload: boolean;
      readonly id: string;
      readonly logo: string;
      readonly name: string;
    };
    readonly videoPlaybackSettings: {
      readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_videoPlaybackSettings">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_viewer">;
  };
};
export type PublicMeetingRecapQuery = {
  response: PublicMeetingRecapQuery$data;
  variables: PublicMeetingRecapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "accessKey"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "public",
    "value": true
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "data",
      "variableName": "data"
    }
  ],
  "concreteType": "PublicRecap",
  "kind": "LinkedField",
  "name": "publicRecap",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "domainUsers",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userExistsForEmail",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowRecapDownload",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCallStart",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCallEnd",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoPosterUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoDuration",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailVttUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "context",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingRecordingSummary",
  "kind": "LinkedField",
  "name": "activeSummary",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TranscriptChapter",
      "kind": "LinkedField",
      "name": "chapters",
      "plural": true,
      "selections": [
        (v21/*: any*/),
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptBulletPoint",
          "kind": "LinkedField",
          "name": "bulletPoints",
          "plural": true,
          "selections": [
            (v22/*: any*/),
            (v21/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "textShort",
              "storageKey": null
            },
            (v23/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TranscriptActionItem",
      "kind": "LinkedField",
      "name": "actionItems",
      "plural": true,
      "selections": [
        (v21/*: any*/),
        (v22/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptActionItemAssignee",
          "kind": "LinkedField",
          "name": "assignees",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userId",
              "storageKey": null
            },
            (v6/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "insertedBlockKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "edited",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TranscriptDecision",
      "kind": "LinkedField",
      "name": "decisions",
      "plural": true,
      "selections": [
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/)
      ],
      "storageKey": null
    },
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeRecapTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingPromptFeedback",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "missingInformation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notFactuallyCorrect",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dontLikeTheTone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "other",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "otherFeedback",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transcript",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGeneratingRecapTemplate",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redactionIsInProgress",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regenerationForLanguageIsInProgress",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAskCopilotConversation",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recordingAndTranscriptWillBeDeleted",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transcriptDeletionReason",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordingVideoDeletionReason",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recordingDataAutoDeletionDate",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userVideoProgress",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "ownerAccount",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicRecapLockVideoPlayback",
          "storageKey": null
        }
      ],
      "type": "ExternalAccount",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "note",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v13/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDemoRecording",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showLowLanguageConfidenceRegenerationBanner",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canRegenerateSummary",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingStats",
  "kind": "LinkedField",
  "name": "meetingStats",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingStatsUser",
      "kind": "LinkedField",
      "name": "userStats",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v6/*: any*/),
        (v5/*: any*/),
        (v40/*: any*/),
        (v41/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "absent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalTalkTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "joinedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "leftAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualStartTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualEndTime",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaType",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingKeyEvent",
  "kind": "LinkedField",
  "name": "meetingKeyEvents",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "participantName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeFromRecordingStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTimeFromRecordingStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadId",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTimestamp",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavourite",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transcriptTxtDownloadUrl",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "RecordingAttendee",
  "kind": "LinkedField",
  "name": "attendees",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "didViewerAttend",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiArtifactsTxtDownloadUrl",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTimestamp",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "users",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v6/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExternal",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "baseRecording",
      "plural": false,
      "selections": [
        (v50/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "MeetingRecordingClip",
  "abstractKey": null
},
v57 = [
  (v3/*: any*/)
],
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowRecapEngagementStats",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PublicMeetingRecapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "FragmentSpread",
            "name": "TranscriptModal_note"
          },
          {
            "args": (v2/*: any*/),
            "kind": "FragmentSpread",
            "name": "TranscriptModal_meetingRecording"
          }
        ],
        "storageKey": null
      },
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "isPublic",
                "value": true
              }
            ],
            "kind": "FragmentSpread",
            "name": "TranscriptModal_viewer"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserVideoPlaybackSettings",
            "kind": "LinkedField",
            "name": "videoPlaybackSettings",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TranscriptVideo_videoPlaybackSettings"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v3/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PublicMeetingRecapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "groupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventStart",
                "storageKey": null
              },
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "meetingRecordings",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingVideoAndTranscriptionDownloadUrl",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subtitlesVttUrl",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanDelete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExternalAttendees",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingSummary",
                    "kind": "LinkedField",
                    "name": "summaries",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v20/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GeneratedRecapSection",
                        "kind": "LinkedField",
                        "name": "recapTemplatesGenerated",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "standardKey",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v44/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "outputFormat",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sectionContent",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v45/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingCommentsData",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": true,
                    "selections": [
                      (v46/*: any*/),
                      (v47/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeetingRecordingCommentsData",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                              (v53/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MeetingRecording",
                        "abstractKey": null
                      },
                      (v56/*: any*/)
                    ],
                    "type": "MeetingRecordingInterface",
                    "abstractKey": "__isMeetingRecordingInterface"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isLocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanEdit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": (v57/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v58/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v40/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "organizer",
                    "plural": false,
                    "selections": (v57/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v13/*: any*/),
              (v18/*: any*/),
              (v16/*: any*/),
              (v25/*: any*/),
              (v24/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v19/*: any*/),
              (v14/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v15/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v12/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingCommentsData",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": true,
                        "selections": [
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v55/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MeetingRecording",
                    "abstractKey": null
                  },
                  (v56/*: any*/)
                ],
                "type": "MeetingRecordingInterface",
                "abstractKey": "__isMeetingRecordingInterface"
              }
            ],
            "type": "MeetingRecording",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserVideoPlaybackSettings",
            "kind": "LinkedField",
            "name": "videoPlaybackSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "playbackRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtitlesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "volume",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "muted",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v3/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v58/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowAiFeatures",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasAccessToRecapTemplates",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "recap_templates"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"recap_templates\")"
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "includeDisabled",
                "value": true
              }
            ],
            "concreteType": "RecapTemplate",
            "kind": "LinkedField",
            "name": "recapTemplates",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "globalKey",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "creator",
                "plural": false,
                "selections": (v57/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "disabled",
                "storageKey": null
              }
            ],
            "storageKey": "recapTemplates(includeDisabled:true)"
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d1dbd99c0bca314e8e11ade71b8c1970",
    "id": null,
    "metadata": {},
    "name": "PublicMeetingRecapQuery",
    "operationKind": "query",
    "text": "query PublicMeetingRecapQuery(\n  $accessKey: ID!\n  $data: String\n) {\n  node(id: $accessKey) {\n    __typename\n    ...TranscriptModal_note_1JfjPu\n    ...TranscriptModal_meetingRecording_1JfjPu\n    id\n  }\n  publicRecap(data: $data) {\n    domainUsers {\n      id\n      email\n      image\n      firstName\n      fullName\n    }\n    userExistsForEmail\n  }\n  viewer {\n    ...TranscriptModal_viewer_10mTr8\n    videoPlaybackSettings {\n      ...TranscriptVideo_videoPlaybackSettings\n      id\n    }\n    account {\n      __typename\n      id\n      name\n      logo\n      allowRecapDownload\n    }\n    id\n  }\n}\n\nfragment ChaptersPanel_meetingRecording on MeetingRecording {\n  id\n  activeSummary {\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n    }\n    id\n  }\n  userVideoProgress\n}\n\nfragment DislikeModal_meetingRecording on MeetingRecording {\n  id\n  canRegenerateSummary\n  activeSummary {\n    id\n    activeRecapTemplate\n    feedback {\n      id\n      missingInformation\n      notFactuallyCorrect\n      dontLikeTheTone\n      other\n      otherFeedback\n    }\n  }\n}\n\nfragment HighlightsPanel_meetingRecording_1JfjPu on MeetingRecording {\n  __typename\n  id\n  activeSummary {\n    summary\n    createdAt\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n      insertedBlockKey\n      edited\n    }\n    decisions {\n      timestamp\n      text\n      context\n    }\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        timestamp\n        text\n        textShort\n        context\n      }\n    }\n    id\n  }\n  title\n  meetingCallEnd\n  isDemoRecording\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  recordingDataAutoDeletionDate\n  meetingRecordedVideoDuration\n  ...utils_AddedOrAvailableUntil_meetingRecording\n  userVideoProgress\n  ownerAccount {\n    __typename\n    id\n  }\n  showLowLanguageConfidenceRegenerationBanner\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1JfjPu\n}\n\nfragment HighlightsPanel_note on Note {\n  id\n  title\n  isLocked\n  viewerCanEdit\n  stream {\n    id\n  }\n}\n\nfragment HighlightsPanel_viewer on Viewer {\n  account {\n    __typename\n    id\n    allowAiFeatures\n    billingAccount {\n      hasAccessToRecapTemplates: hasAccessToFeature(feature: recap_templates)\n      id\n    }\n  }\n  user {\n    id\n  }\n  recapTemplates(includeDisabled: true) {\n    id\n    title\n    icon\n    order\n    globalKey\n    visibility\n    updatedAt\n    creator {\n      id\n    }\n    disabled\n  }\n}\n\nfragment RecapHistory_meetingRecording on MeetingRecording {\n  id\n  meetingRecordedVideoDuration\n  activeSummary {\n    id\n  }\n  summaries {\n    id\n    summary\n    createdAt\n    recapTemplatesGenerated {\n      type\n      standardKey\n      title\n      order\n      outputFormat\n      sectionContent\n    }\n    creator {\n      id\n      fullName\n      email\n      image\n    }\n  }\n}\n\nfragment StatsPanel_note on Note {\n  eventStart\n  eventEnd\n  account {\n    __typename\n    allowRecapEngagementStats\n    id\n  }\n}\n\nfragment Timeline_meetingKeyEvents on MeetingRecording {\n  meetingKeyEvents {\n    eventType\n    participantName\n    timeFromRecordingStart\n    endTimeFromRecordingStart\n    duration\n  }\n  comments {\n    threadId\n    startTimestamp\n  }\n}\n\nfragment TranscriptModalContentStats on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n  meetingStats {\n    userStats {\n      email\n      fullName\n      image\n      isGuest\n      isTopUser\n      absent\n      totalTalkTime\n      percentage\n      joinedAt\n      leftAt\n    }\n    actualStartTime\n    actualEndTime\n  }\n  id\n}\n\nfragment TranscriptModalContent_note on Note {\n  id\n  __typename\n  viewerCanEdit\n  stream {\n    id\n  }\n  ...TranscriptPanel_note\n}\n\nfragment TranscriptModalContent_viewer on Viewer {\n  recapTemplates(includeDisabled: true) {\n    id\n    globalKey\n    title\n  }\n}\n\nfragment TranscriptModalGenerating_RedactingPreview_meetingRecording on MeetingRecording {\n  mediaType\n}\n\nfragment TranscriptModal_meetingRecording_1JfjPu on MeetingRecording {\n  __typename\n  id\n  title\n  meetingRecordedVideoDuration\n  meetingRecordedVideoUrl\n  transcript\n  activeSummary {\n    id\n    summary\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n    }\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n    }\n    decisions {\n      timestamp\n      text\n    }\n  }\n  isGeneratingRecapTemplate\n  redactionIsInProgress\n  regenerationForLanguageIsInProgress\n  hasAskCopilotConversation\n  thumbnailVttUrl\n  meetingCallStart\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  meetingRecordingVideoDeletionReason\n  recordingDataAutoDeletionDate\n  userVideoProgress\n  ownerAccount {\n    __typename\n    id\n    ...utils_usePublicRecapLockVideoPlayback_ownerAccount\n  }\n  note {\n    __typename\n    title\n    id\n  }\n  ...HighlightsPanel_meetingRecording_1JfjPu\n  ...ChaptersPanel_meetingRecording\n  ...TranscriptVideo_meetingRecording_1JfjPu\n  ...TranscriptPanel_Transcript_meetingRecording_1JfjPu\n  ...DislikeModal_meetingRecording\n  ...TranscriptModalContentStats\n  ...TranscriptModalGenerating_RedactingPreview_meetingRecording\n}\n\nfragment TranscriptModal_note_1JfjPu on Note {\n  id\n  groupName\n  eventStart\n  createdAt\n  title\n  meetingRecordings {\n    __typename\n    id\n    title\n    meetingCallStart\n    meetingCallEnd\n    meetingVideoAndTranscriptionDownloadUrl\n    meetingRecordedVideoUrl\n    meetingRecordedVideoPosterUrl\n    meetingRecordedVideoDuration\n    subtitlesVttUrl\n    thumbnailVttUrl\n    viewerCanDelete\n    hasExternalAttendees\n    activeSummary {\n      id\n    }\n    ...TranscriptModal_meetingRecording_1JfjPu\n    ...TranscriptVideo_meetingRecording_1JfjPu\n    ...utils_useLongestMeetingRecording_meetingRecordings\n    ...utils_AddedOrAvailableUntil_meetingRecording\n    ...utils_useGetURL_recording\n    ...RecapHistory_meetingRecording\n    ...Timeline_meetingKeyEvents\n    ownerAccount {\n      __typename\n      id\n      ...utils_usePublicRecapLockVideoPlayback_ownerAccount\n    }\n    mediaType\n  }\n  ...HighlightsPanel_note\n  ...StatsPanel_note\n  ...TranscriptModalContent_note\n}\n\nfragment TranscriptModal_viewer_10mTr8 on Viewer {\n  videoPlaybackSettings {\n    ...TranscriptVideo_videoPlaybackSettings\n    id\n  }\n  account {\n    __typename\n    id\n    name\n    logo\n    allowRecapDownload\n    allowRecapEngagementStats\n  }\n  user {\n    isGuest\n    id\n  }\n  ...TranscriptModalContent_viewer\n  ...HighlightsPanel_viewer\n}\n\nfragment TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1JfjPu on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  transcript\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    attendees {\n      fullName\n      email\n      image\n      isTopUser\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      attendees {\n        fullName\n        email\n        image\n        isTopUser\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_TranscriptSegment_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  id\n  ownerAccount {\n    __typename\n    id\n  }\n  ...utils_useGetURL_recording\n}\n\nfragment TranscriptPanel_TranscriptSegment_note on Note {\n  id\n}\n\nfragment TranscriptPanel_Transcript_meetingRecording_1JfjPu on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    activeSummary {\n      id\n    }\n    canRegenerateSummary\n    comments {\n      threadId\n      startTimestamp\n      endTimestamp\n      count\n      users {\n        id\n        email\n        fullName\n        image\n        isExternal\n      }\n    }\n    showLowLanguageConfidenceRegenerationBanner\n  }\n  ownerAccount {\n    __typename\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_meetingRecording\n  ...Timeline_meetingKeyEvents\n  ...TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1JfjPu\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1JfjPu\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n}\n\nfragment TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  transcript\n  ownerAccount {\n    __typename\n    id\n  }\n}\n\nfragment TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1JfjPu on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    attendees {\n      fullName\n      email\n      image\n      isTopUser\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      attendees {\n        fullName\n        email\n        image\n        isTopUser\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_note on Note {\n  id\n  isLocked\n  viewerCanEdit\n  noteuserSet {\n    id\n    user {\n      id\n      email\n      fullName\n      isGuest\n      image\n    }\n  }\n  event {\n    organizer {\n      id\n    }\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_note\n}\n\nfragment TranscriptVideo_meetingRecording_1JfjPu on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  ... on MeetingRecording {\n    userVideoProgress\n    didViewerAttend\n  }\n  ...Video_meetingRecording\n}\n\nfragment TranscriptVideo_videoPlaybackSettings on UserVideoPlaybackSettings {\n  id\n  playbackRate\n  subtitlesEnabled\n  volume\n  muted\n}\n\nfragment Video_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  createdAt\n  isFavourite\n  meetingRecordedVideoUrl\n  transcriptTxtDownloadUrl\n  meetingRecordedVideoPosterUrl\n  mediaType\n  ... on MeetingRecording {\n    meetingCallEnd\n    aiArtifactsTxtDownloadUrl\n    activeSummary {\n      chapters {\n        timestamp\n        title\n        bulletPoints {\n          text\n          timestamp\n          textShort\n          context\n        }\n      }\n      id\n    }\n    ...Timeline_meetingKeyEvents\n  }\n}\n\nfragment utils_AddedOrAvailableUntil_meetingRecording on MeetingRecording {\n  meetingCallEnd\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  meetingRecordingVideoDeletionReason\n  recordingDataAutoDeletionDate\n}\n\nfragment utils_useGetURL_recording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  ... on MeetingRecording {\n    id\n  }\n  ... on MeetingRecordingClip {\n    id\n  }\n}\n\nfragment utils_useLongestMeetingRecording_meetingRecordings on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n}\n\nfragment utils_usePublicRecapLockVideoPlayback_ownerAccount on ExternalAccount {\n  publicRecapLockVideoPlayback\n}\n"
  }
};
})();

(node as any).hash = "9c536b78b5f159a0a4089cb0dff23ac0";

export default node;
